import { render } from "./BreakoutRoomsParticipantsEditor.vue?vue&type=template&id=23963606&scoped=true"
import script from "./BreakoutRoomsParticipantsEditor.vue?vue&type=script&lang=js"
export * from "./BreakoutRoomsParticipantsEditor.vue?vue&type=script&lang=js"

import "./BreakoutRoomsParticipantsEditor.vue?vue&type=style&index=0&id=23963606&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23963606"]])

export default __exports__